<template>
	<v-row
		v-if='$vuetify.breakpoint.mdAndDown || chips.length'
		align='center'
		justify='space-between'
		no-gutters
		style='width: 100%; max-width: 100%'
		:class='$vuetify.breakpoint.lgAndUp ? "mb-4 mt-n1" : ""'
	>
		<v-col v-if='$vuetify.breakpoint.lgAndUp' cols='6' class='font-weight-bold'>
			Deine angewandten Filter:
		</v-col>

		<v-col v-else cols='12' class='font-weight-bold'>
			Deine angewandten Filter <span v-if='chips.length'>({{ chips.length }})</span>
		</v-col>


		<v-col v-if='$vuetify.breakpoint.lgAndUp' class='text-right' cols='6'>
			<v-btn
				v-if='chips.length > 0'
				color='primary'
				class='font-weight-bold'
				depressed
				text
				small
				@click='$store.actions.resetAllFilters'
			>
				Alle Filter löschen
				<v-icon class='ml-2' size='12'>
					far fa-trash-alt
				</v-icon>
			</v-btn>

			<search-order-dialog :chips='chips' />
		</v-col>

		<v-col v-if='chips.length' style='position: relative; width: 1%;'>
			<div v-if='$vuetify.breakpoint.xsOnly' class='chip-gradient' />
			<v-chip-group
				:max='0'
				:show-arrows='$vuetify.breakpoint.smOnly'
				active-class=''
				style='width: 100%'
				:column='$vuetify.breakpoint.lgAndUp'
			>
				<v-chip
					v-for='chip in chips'
					:key='chip.text'
					class='primary--text beige'
					:class='$vuetify.breakpoint.lgAndUp ? "font-weight-bold" : "mobile-chip"'
					small
					@click='removeChip(chip)'
				>
					{{ chip.text }}
					<v-icon class='ml-2' color='primary' size='14'>
						{{ $vuetify.breakpoint.mdAndDown ? 'fal fa-times' : 'far fa-times' }}
					</v-icon>
				</v-chip>
			</v-chip-group>


		</v-col>

		<v-col v-else class='primary--text text--lighten-2' style='min-height: 38px; padding-top: 6px'>
			Keine <span class='hide-xxs-only'>Filter</span> angewendet
		</v-col>
	</v-row>
</template>

<script>
	import utils from '../libs/utils'
  import SearchOrderDialog from '@/components/SearchOrderDialog'

	export default {
		name: 'FilterChips',
    components: { SearchOrderDialog },
		data: () => {
			return {
				chips: []
			}
		},
    watch: {
      chips: function (val) {
        this.$bus.$emit('chipsChange', val)
        this.$forceUpdate()
      },
    },
		mounted() {
			this.updateChips()
			this.$bus.$on('filters-updated', () => {
        this.updateChips();
      })
		},

		methods: {
			updateChips() {
				const chips = []

				for (let filter of this.$store.filters) {
					if (filter.selectedValues) {
            if (filter.type === 'duration') {
              let text  ='';
              if(filter.selectedValues[0].default === true && filter.selectedValues[1].default === true) {
                continue;
              } else {
                if(filter.selectedValues[1].value == -1) {
                  text = filter.selectedValues[0].label;
                }else {
                  text = filter.selectedValues[0].label + ', ' +utils.getLabelForSelectedValue(filter, filter.selectedValues[1])
                }
              }
              let chip = {
                name: filter.name,
                text: text,
                selectedValuesItem: filter.selectedValues
              }
              chips.push(chip)
            } else {
              for (let value of filter.selectedValues) {
                if (value.default) {
                  continue
                }
                let chip = {
                  name: filter.name,
                  text: utils.getLabelForSelectedValue(filter, value, true),
                  selectedValuesItem: value
                }
                chips.push(chip)
              }
            }
          }
				}
				this.chips = chips
			},

			async removeChip(chip) {
				const filterInStore = this.$store.filters.find(filter => filter.name === chip.name)
        const filterName = filterInStore.name;
				let dependencyFilters = this.$store.filters.filter(
				    filter => filter.type === 'dependency' && filter.depends.on === filterName
        );
        let dependencies = [];
        dependencyFilters.forEach((filter) => {
          if(!dependencies.includes(filter.name)) {
            dependencies.push(filter.name)
          }
        });
        this.chips.forEach( async (filterChip) => {
          if(dependencies.includes(filterChip.name)) {
            await this.removeChip(filterChip)
          }
        })
        if(filterInStore.type === 'duration') {
          delete filterInStore.selectedValues;
        } else {
          const selectedValuesItemIndex = filterInStore.selectedValues.indexOf(chip.selectedValuesItem)
          filterInStore.selectedValues.splice(selectedValuesItemIndex, 1)
        }
        await this.$store.actions.updateFiltersInStore(filterInStore)

			}
		}
	}
</script>

<style scoped>
	.chip-gradient {
		height: 98%;
		width: 28px;
		pointer-events: none;
		position: absolute;
		right: 0;
		z-index: 2;
		background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 20%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 1) 85%, rgba(255, 255, 255, 1) 100%);
	}

	.mobile-chip {
		height: 22px !important;
	}
</style>
